module.exports = __webpack_public_path__ + "static/media/StudentContent2.628622f1.svg";